import { isImgixUrl, resolveByosImgixSrc } from '@air/component-imgix-image';

export const getCompatibleImageUrl = (url: string): string => {
  const resolved = resolveByosImgixSrc(url);

  if (!isImgixUrl(resolved)) {
    return url;
  }

  try {
    const urlObj = new URL(resolved);
    urlObj.searchParams.set('auto', 'format');

    return urlObj.toString();
  } catch {
    return resolved;
  }
};
